import React from 'react';
import {useNavigate} from "react-router-dom";
import linkButtonImage from "../../../assets/images/mediaEvent/link-btn.png";
import '../../../assets/css/pages/mediaEvent/section/mediaEventsCard.scss';

const MediaEventsCard = ({data}) => {
    const {id, smallImageBase64, smallImageTag, shortDescription} = data;
    const navigate = useNavigate();
    const handleClick = (mediaEventId) => {
        navigate(`/media-events/${mediaEventId}`);
    }
    return (

            <div className="custom-media-and-events-card-public">
                <div className="custom-media-and-events-card-header">
                    <img src={`data:image/jpg;base64,${smallImageBase64}`} alt={smallImageTag}/>
                </div>
                <div className="custom-media-and-events-card-body">
                    <span className="media-and-events-card-name">{shortDescription}</span>
                </div>
                <div className="custom-media-and-events-card-footer">
                    <button onClick={() => handleClick(id)} type="button" className="link-btn">
                        <img src={linkButtonImage} alt=""/>
                    </button>
                </div>
            </div>
    );
};

export default MediaEventsCard;
